import React from 'react'
import AppDetail from './AppDetail'
import AppDetail2 from './AppDetail2'
import AppDetail3 from './AppDetail3'

export default function About() {
  return (
    <div id="about" className='flex flex-col min-h-screen scroll-mt-20 p-6 my-12 gap-10'>
        <AppDetail />
        <AppDetail2 />
        <AppDetail3 />
    </div>
  )
}
